import React from "react"
import { t } from '../../../i18n'
import CustomButton from "../shared/CustomButton"
import InputKeyValue from "../shared/InputKeyValue"
import { ArrowLeftLG } from "../normalizer";

const PasswordRecovery = ({
  client_logo: ClientLogo,
  client,
  recovepassword
}) => {

  return (
    <div className="password-recovery">
      <div className="password-recovery__container">
        <div className="password-recovery__logo">
          <img
            className="password-recovery__logo-image"
            src={client.logo.url}
            alt=""
          />
        </div>
        <div className="password-recovery__back-to-login">
          <CustomButton
            className="password-recovery__back-to-login-link"
            link
            tight
            to={"/login"}
          >
            <ArrowLeftLG className="password-recovery__back-to-login-link-icon" />
            Voltar
          </CustomButton>
        </div>
        <div className="password-recovery__header">
          <div className="password-recovery__title">Recuperar palavra-passe</div>
          <div className="password-recovery__subtitle">
            Introduza o seu email e enviaremos as instruções para definir uma 
            <br/>nova palavra-passe.
          </div>
        </div>
        <form className="password-recovery__form" id="password-recovery__form" onSubmit={recovepassword}>
          <div className="password-recovery__form-email">
            <InputKeyValue
              title="Email"
              placeholder={"exemplo@email.com"}
              required
              type="text"
              name="emailOrLogin"
            />
          </div>
        </form>
        <div className="password-recovery__actions">
          <CustomButton type="submit"  className="password-recovery__actions-button" form="password-recovery__form">
            {t("gamification2026.login.request-new-password")}
          </CustomButton>
        </div>
      </div>
    </div>
  );
}

export default PasswordRecovery
